<!--
  --
  -- 予約内容確認ページ
  --
  -->
<template>
  <c-container form wide>
    <c-book-header>予約内容を確認</c-book-header>

    <!-- 操作カード -->
    <c-confirm-card class="mb-6" />

    <v-row>
      <!-- スケジュールと車両 -->
      <v-col cols="12" sm="6" class="d-flex flex-column">
        <c-book-summary-card class="order-0 order-sm-0" />
        <div class="mb-6 order-1"/>
        <c-car-card class="order-2 order-sm-2"/>
        <div class="mb-6 order-3"/>
        <c-remark-card class="order-4 order-sm-4" />
      </v-col>

      <!-- 料金 -->
      <v-col cols="12" sm="6">
        <c-basic-card class="mb-6"/>
        <c-options-card class="mb-6"/>
        <c-charge-card/>
      </v-col>
    </v-row>
  </c-container>
</template>

<style>
.AttributesIcon {
  display: inline-block;
  padding: 2px 4px;
  margin-right: 4px;
  margin-bottom: 4px;
  border-radius: 4px;
}
.Attributes_Dark {
  color: #fff;
}
.Attributes_Bright {
  color: #000;
}
.confirm_vkey_link {
  width: 100%;
  height: 16px;
  margin-top: 12px;
  margin-bottom: 12px;
}
.confirm_vkey_link > a {
  display: inline-block;
  float: right;
  padding: 4px 8px;
  border-radius: 15px;
  border: 1px #cccccc solid;
  text-decoration: none;
  text-align: center;
}
</style>

<script>
import page from '@/mixins/page'
import CBookHeader from '@/pages/book/components/CBookHeader'
import CConfirmCard from './CConfirmCard'
import CBookSummaryCard from '@/pages/book/components/CBookSummaryCard'
import CBasicCard from './CBasicCard'
import CChargeCard from './CChargeCard'
import CCarCard from './CCarCard'
import COptionsCard from './COptionsCard'
import CRemarkCard from './CRemarkCard'

export default {
  name: 'Confirm',
  mixins: [
    page('予約内容を確認')
  ],
  components: {
    CBookHeader,
    CConfirmCard,
    CBookSummaryCard,
    CChargeCard,
    CCarCard,
    COptionsCard,
    CRemarkCard,
    CBasicCard
  }
}
</script>
